module.exports = __webpack_public_path__ + "fonts/nunito-sans-v8-latin-regular.c79c0092.woff2";